import { render, staticRenderFns } from "./CmgRecaptcha.vue?vue&type=template&id=d71c6e96&scoped=true&lang=pug"
import script from "./cmg-recaptcha.ts?vue&type=script&lang=ts&external"
export * from "./cmg-recaptcha.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d71c6e96",
  null
  
)

export default component.exports